import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=20a92686&scoped=true&lang=html&"
import script from "./bankList.vue?vue&type=script&lang=js&"
export * from "./bankList.vue?vue&type=script&lang=js&"
import style0 from "./bankList.vue?vue&type=style&index=0&id=20a92686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a92686",
  null
  
)

export default component.exports